/**
 * Footer columns.
 *
 * The footer's menu and contact columns are <details> elements: an accordion on a phone,
 * where vertical space is scarce, and a plain set of columns on a desktop, where it is not.
 *
 * One set of markup serves both because this element drives the `open` attribute from a
 * media query rather than from the visitor. Above the tablet breakpoint every panel is
 * forced open and its summary leaves the tab order — a heading is not a control when it
 * cannot close anything. Below it, the panels return to being real disclosures.
 *
 * Without JavaScript the panels stay as authored: open, which is the safe failure.
 */

const EXPANDED = window.matchMedia('screen and (min-width: 768px)');

class FooterColumns extends HTMLElement {
  connectedCallback() {
    this.panels = Array.from(this.querySelectorAll('details'));
    this.apply = this.apply.bind(this);
    this.apply();
    EXPANDED.addEventListener('change', this.apply);
  }

  disconnectedCallback() {
    EXPANDED.removeEventListener('change', this.apply);
  }

  apply() {
    const expanded = EXPANDED.matches;

    this.panels.forEach((panel) => {
      const summary = panel.querySelector('summary');

      if (expanded) {
        panel.open = true;
      }

      if (summary) {
        // -1 rather than removing the attribute: a summary is focusable by default, so the
        // attribute has to stay and be reset to 0 when the accordion comes back.
        summary.tabIndex = expanded ? -1 : 0;
      }
    });
  }
}

customElements.define('footer-columns', FooterColumns);
